import { List } from 'immutable';
import TypeItem, { TypeItems } from 'records/TypeItem';
import BaseList from 'records/BaseList';

import {
  TYPE_ITEMS_ASYNC_ACTION_START,
  TYPE_ITEMS_ASYNC_ACTION_ERROR,
  TYPE_ITEMS_ASYNC_UPDATE_ACTION_SUCCESS,
  TYPE_ITEMS_PARENT_ID_ASYNC_UPDATE_ACTION_SUCCESS,
} from 'actions/type-items';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [TYPE_ITEMS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [TYPE_ITEMS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [TYPE_ITEMS_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    let typeItemsPayload = TypeItems(action.data);
    if (state.data) {
      typeItemsPayload = TypeItem.mergeTypeItems(state.data, typeItemsPayload);
    }
    return state.merge({
      loading: false,
      errorMessage: null,
      data: typeItemsPayload,
    });
  },
  [TYPE_ITEMS_PARENT_ID_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    let typeItemsPayload = TypeItems(action.data, action.typeItemIdParent);
    if (state.data) {
      typeItemsPayload = TypeItem.mergeTypeItems(state.data, typeItemsPayload);
    }
    return state.merge({
      loading: false,
      errorMessage: null,
      data: typeItemsPayload,
    });
  },
};

export default function typeItems(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
